import { BillingPlan } from '@cycle-app/graphql-codegen';
import { Tooltip } from '@cycle-app/ui';
import { ComponentProps } from 'react';

import { PageId } from 'src/constants/routing.constant';
import { useCurrentBilling } from 'src/hooks';
import { useNavigate } from 'src/hooks/useNavigate';

import { Container } from './BillingBadge.styles';

type Props = ComponentProps<typeof Container> & {
  plan?: BillingPlan;
};

export const BillingBadge = ({
  plan, ...props
}: Props) => {
  const billing = useCurrentBilling();
  return (
    <Container {...props} $plan={plan ?? billing?.plan}>
      {getBillingLabel(plan ?? billing?.plan)}
    </Container>
  );
};

const getBillingLabel = (plan?: BillingPlan) => {
  switch (plan) {
    case BillingPlan.Free:
      return 'Starter';
    case BillingPlan.Standard:
      return 'Pro';
    default:
      return 'Business+';
  }
};

export const BillingBadgeClickable = () => {
  const billing = useCurrentBilling();
  const { navigate } = useNavigate();
  return (
    <Tooltip
      content={billing?.plan === BillingPlan.BusinessPlus ? 'Explore Business+' : 'Explore Pro'}
      placement="top"
      withPortal
    >
      <BillingBadge
        onClick={(e: MouseEvent) => {
          e.stopPropagation();
          e.preventDefault();
          navigate(PageId.BillingUpgradePlan, {
            plan: billing?.plan === BillingPlan.BusinessPlus ? BillingPlan.BusinessPlus : BillingPlan.Standard,
          });
        }}
      />
    </Tooltip>
  );
};
